import * as Yup from 'yup';
import getUsedPercentValue from '../../utils/getUsedPercentValue';
import {
  paymentProviders,
  paymentTypes,
  shippingTypes,
} from '../../utils/constants';

const isCreditCardNotNeeded = (
  loyaltyCashback,
  voucher,
  totalPrice,
  isPostPaid,
) => {
  if (loyaltyCashback) {
    const usedCashback = getUsedPercentValue(
      totalPrice,
      loyaltyCashback.maxCashbackPercentage,
      loyaltyCashback.availableCashback,
    );

    if (usedCashback === totalPrice) {
      return true;
    }
  }

  if (voucher && voucher.total >= totalPrice) {
    return true;
  }

  if (isPostPaid) {
    return true;
  }

  return false;
};

const orderReviewFormSchema = (props) => {
  const { providerId, selectedStore } = props;

  const isGetnetAntiFraud =
    providerId === paymentProviders.GETNET && selectedStore?.antiFraudEnabled;

  return Yup.object().shape({
    shippingType: Yup.string()
      .required('formValidation:fieldRequired')
      .test(
        'invalid-shipping-type',
        'formValidation:invalidShippingType',
        function invalidShippingType(value) {
          const { selectedStore: store } = props;
          const { tagEnabled, takeoutEnabled, deliveryEnabled } = store;

          if (
            (!tagEnabled && value === shippingTypes.TAG) ||
            (!deliveryEnabled && value === shippingTypes.ADDRESS) ||
            (!takeoutEnabled && value === shippingTypes.TAKEOUT)
          ) {
            return false;
          }

          return true;
        },
      ),
    creditCardOption: Yup.string().test(
      'must-use-credit-card',
      'formValidation:fieldRequired',
      function mustUseCreditCard(value) {
        const {
          loyaltyCashback,
          totalPrice,
          paymentOnDeliveryOnly,
          isPostPaid,
        } = props;
        const { paymentType, voucher } = this.parent;

        if (
          paymentOnDeliveryOnly &&
          value !== paymentTypes.CREDIT_CARD_ONLINE
        ) {
          return true;
        }

        if (paymentType !== paymentTypes.CREDIT_CARD_ONLINE) {
          return true;
        }

        if (
          isCreditCardNotNeeded(
            loyaltyCashback,
            voucher,
            totalPrice,
            isPostPaid,
          )
        ) {
          return true;
        }

        return !!value;
      },
    ),
    useCashback: Yup.bool(),
    paymentType: Yup.string(),
    installments: Yup.number(),

    securityCode: isGetnetAntiFraud
      ? Yup.string().when('paymentType', (paymentType) => {
          if (paymentType === paymentTypes.CREDIT_CARD_ONLINE) {
            return Yup.string()
              .required('formValidation:securityCodeRequired')
              .test(
                'valid-security-code',
                'formValidation:invalidSecurityCode',
                (value) => {
                  if (!value) return false;
                  const digits = value.replace(/\D/g, '');
                  return digits.length >= 3 && digits.length <= 4;
                },
              );
          }
          return Yup.string();
        })
      : Yup.string(),

    comment: Yup.string().max(1024, 'formValidation:commentTooLong'),
    name: props.requiredFields?.includes('name')
      ? Yup.string().required('formValidation:fieldRequired')
      : Yup.string(),
    phone: props.requiredFields?.includes('phone')
      ? Yup.string().required('formValidation:fieldRequired')
      : Yup.string(),
  });
};

export default orderReviewFormSchema;
